var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_74",
    "data-name": "Group 74",
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.322,
    height: 197.322,
    viewBox: "0 0 197.322 197.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#f79653",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.661,
    cy: 98.661,
    rx: 98.661,
    ry: 98.661,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.661,
    cy: 98.661,
    rx: 98.161,
    ry: 98.161,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(63.142 51.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M239.34,251.619A21.981,21.981,0,1,0,223.8,245.18,21.258,21.258,0,0,0,239.34,251.619Z",
    transform: "translate(-201.859 -207.672)",
    fill: "none",
    stroke: "#cf561e",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M284.3,259.321a54.382,54.382,0,0,0-.74-5.764,45.264,45.264,0,0,0-1.417-5.8,28.723,28.723,0,0,0-2.384-5.406,20.325,20.325,0,0,0-3.592-4.682,15.808,15.808,0,0,0-5.161-3.242,17.811,17.811,0,0,0-6.588-1.193c-.932,0-1.832.381-3.571,1.513-1.07.7-2.324,1.507-3.72,2.4a21.278,21.278,0,0,1-4.814,2.12,18.691,18.691,0,0,1-11.775,0,21.293,21.293,0,0,1-4.811-2.118c-1.384-.886-2.637-1.693-3.723-2.4-1.739-1.132-2.639-1.515-3.57-1.515a17.792,17.792,0,0,0-6.588,1.195,15.822,15.822,0,0,0-5.163,3.242,20.437,20.437,0,0,0-3.591,4.682,28.609,28.609,0,0,0-2.382,5.406,45.315,45.315,0,0,0-1.419,5.8,54.253,54.253,0,0,0-.74,5.768c-.121,1.741-.181,3.554-.181,5.387,0,4.763,1.514,8.619,4.5,11.461,2.947,2.806,6.848,4.228,11.594,4.228H268.39a16.2,16.2,0,0,0,11.594-4.228c2.986-2.84,4.5-6.7,4.5-11.461C284.483,262.871,284.421,261.058,284.3,259.321Z",
    transform: "translate(-208.37 -189.17)",
    fill: "none",
    stroke: "#cf561e",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.2e0008b8b8f1dcbaab5470f480ef4a1d.svg";
export { ForwardRef as ReactComponent };